"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _gql;
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_NAMES_WHITELIST = exports.subgraphUrlFromChainId = void 0;
const connect_thegraph_1 = require("@1hive/connect-thegraph");
const queries = __importStar(require("./queries"));
const parsers_1 = require("./parsers");
function subgraphUrlFromChainId(chainId, staging = false) {
    const stagingFragment = staging ? '-staging' : '';
    // xDai
    if (chainId === 100) {
        return `https://api.thegraph.com/subgraphs/name/commonsswarm/aragon-hatch-xdai${stagingFragment}`;
    }
    return null;
}
exports.subgraphUrlFromChainId = subgraphUrlFromChainId;
exports.APP_NAMES_WHITELIST = ['marketplace-hatch'];
class HatchConnectorTheGraph {
    constructor(config) {
        _gql.set(this, void 0);
        if (!config.subgraphUrl) {
            throw new Error('HatchConnectorTheGraph requires subgraphUrl to be passed.');
        }
        __classPrivateFieldSet(this, _gql, new connect_thegraph_1.GraphQLWrapper(config.subgraphUrl, {
            pollInterval: config.pollInterval,
            verbose: config.verbose,
        }));
    }
    async disconnect() {
        __classPrivateFieldGet(this, _gql).close();
    }
    generalConfig(id, contractCache) {
        return __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.GENERAL_CONFIG('query'), { id }, async (result) => await parsers_1.parseGeneralConfig(result, contractCache));
    }
    onGeneralConfig(id, callback, contractCache) {
        return __classPrivateFieldGet(this, _gql).subscribeToQueryWithParser(queries.GENERAL_CONFIG('subscription'), { id }, callback, async (result) => await parsers_1.parseGeneralConfig(result, contractCache));
    }
    contributors(appAddress, first, skip, orderBy, orderDirection) {
        return __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.ALL_CONTRIBUTORS('query'), { appAddress, first, skip, orderBy, orderDirection }, (result) => parsers_1.parseContributors(result));
    }
    onContributors(appAddress, first, skip, orderBy, orderDirection, callback) {
        return __classPrivateFieldGet(this, _gql).subscribeToQueryWithParser(queries.ALL_CONTRIBUTORS('subscription'), { appAddress, first, skip, orderBy, orderDirection }, callback, (result) => parsers_1.parseContributors(result));
    }
    contributor(id) {
        return __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.CONTRIBUTOR('query'), { id }, (result) => parsers_1.parseContributions(result));
    }
    onContributor(id, callback) {
        return __classPrivateFieldGet(this, _gql).subscribeToQueryWithParser(queries.CONTRIBUTOR('subscription'), { id }, callback, (result) => parsers_1.parseContributor(result));
    }
    contributions(appAddress, contributor, first, skip, orderBy, orderDirection) {
        return __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.ALL_CONTRIBUTIONS('query'), { appAddress, contributor, first, skip, orderBy, orderDirection }, (result) => parsers_1.parseContributions(result));
    }
    onContributions(appAddress, contributor, first, skip, orderBy, orderDirection, callback) {
        return __classPrivateFieldGet(this, _gql).subscribeToQueryWithParser(queries.ALL_CONTRIBUTIONS('subscription'), { appAddress, contributor, first, skip, orderBy, orderDirection }, callback, (result) => parsers_1.parseContributions(result));
    }
}
exports.default = HatchConnectorTheGraph;
_gql = new WeakMap();
//# sourceMappingURL=connector.js.map